module.exports = __webpack_public_path__ + "static/media/minuteCount.2b5a5674.png";